// import cbxLogo from "../../images/product1.png";
import cbxLogo from "../../images/product1.png";
import {
  AiOutlineInteraction,
  // AiOutlineExport,
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlineSetting,
  AiOutlineCheckCircle,
  AiOutlineTeam,
  AiOutlineProfile,
  AiOutlineStock,
} from "react-icons/ai";
import {
  MdOutlinePayment,
  MdSettings,
  MdHolidayVillage,
  MdAccessTime,
  MdCategory,
  MdPunchClock
} from "react-icons/md";
import {
  BsClipboardCheck,
  BsCalendarCheck,
  BsCalendarDay,
  BsCalendarX,
  BsClockHistory,
  BsClock,
  BsPerson,
} from "react-icons/bs";

import {
  BsJournalText,
  BsClipboardData,
  BsCashStack,
  BsListCheck,
} from "react-icons/bs";

import { FaNotesMedical } from "react-icons/fa";

import { BsPersonPlus, BsPersonDash, BsPersonCheck } from "react-icons/bs";
import { FaUserClock } from "react-icons/fa";
import { MdBadge } from "react-icons/md";

import { FaTruckMoving, FaCarSide } from "react-icons/fa";
import { MdAssignmentLate, MdHowToReg } from "react-icons/md";
import { AiOutlineFileExclamation } from "react-icons/ai";
import { RiUserUnfollowLine } from "react-icons/ri";
import { HiOutlineDocumentAdd } from "react-icons/hi";
import { BsGraphUpArrow } from "react-icons/bs";
import { BiFolderOpen } from "react-icons/bi";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { FaMoneyCheckAlt } from "react-icons/fa";
import { AiOutlineCalendar } from "react-icons/ai";
import { BiCheckCircle } from "react-icons/bi";

import { MdPeopleOutline } from "react-icons/md";
import { MdPersonAddAlt } from "react-icons/md";
import { MdAutorenew } from "react-icons/md";
import { MdNoteAdd } from "react-icons/md";
import { MdEventBusy } from "react-icons/md";
import { MdCheckCircleOutline } from "react-icons/md";
import { HiUsers } from "react-icons/hi";

import { Link } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const NewSidebarOld = () => {
  const [showSampleRequestMenu, setShowSampleRequestMenu] = useState(false);

  //   useEffect(() => {
  //     const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));

  //     const userAccessGroup = currentUserObject[0].accessgrp;

  //     if (
  //       userAccessGroup?.trim().toUpperCase() === "ADMIN" ||
  //       userAccessGroup?.trim().toUpperCase() === "CADMIN" ||
  //       userAccessGroup?.trim().toUpperCase() === "CACCOUNTS" ||
  //       userAccessGroup?.trim().toUpperCase() === "C ACC JUNIOR"
  //     ) {
  //       setShowSampleRequestMenu(true);
  //     }
  //   }, []);

  const navigate = useNavigate();

  const onSignOut = () => {
    localStorage.clear();
    navigate("/");
  };

  const [isOpen, setIsOpen] = useState(true);
  const [selected, setSelected] = useState("leave");

  const [expandedPanel, setExpandedPanel] = useState(false);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  return (
    <aside
      className="fixed top-0 left-0 h-screen w-24 bg-[#F9FAFA] overflow-y-auto scrollbar-none px-2 py-4"
      style={{ zIndex: 10 }}
    >
      <ul className="flex flex-col items-center gap-3 mt-20">
        {/* <div className="w-[80px]">
            <Link
              to="home"
              // className="bg-[#2663EB] flex flex-col shadow-md justify-center items-center  rounded text-center p-2 transition-all duration-200 ease-in-out group-hover:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
              className="bg-[#FFFFFF] flex flex-col shadow-md justify-center items-center  rounded-2xl text-center p-1 transition-all duration-200 ease-in-out group-hover:bg-[#2663EB]  hover:-translate-y-1 hover:scale-80 active:scale-95 active:bg-red-500  group-active:bg-red-300 group-focus:bg-red-300 group-focus:outline-yellow-500"
            >
              <AiOutlineHome className="w-6 h-6 mb-1 text-[#787878] group-hover:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
              <span className="text-[0.65rem] font-semibold text-[#787878] group-hover:text-white transition-colors duration-200 group-hover:animate-bounce  hover:scale-110">
                Home
              </span>
            </Link>
          </div> */}
        <div className="w-[80px] relative">
          <NavLink
            to="home"
            className={({ isActive }) =>
              `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
       transition-all duration-200 ease-in-out group
       ${
         isActive
           ? "bg-[#2663EB] text-white"
           : "bg-white hover:bg-blue-200 hover:text-[#2663EB]"
       }`
            }
          >
            {({ isActive }) => (
              <>
                {/* Left Indicator */}
                {isActive && (
                  <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                )}

                <AiOutlineHome
                  className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                    isActive ? "text-white" : "text-[#787878]"
                  }`}
                />

                <span
                  className={`text-[0.65rem] font-semibold transition-colors duration-200 ${
                    isActive ? "text-white" : "text-[#787878]"
                  }`}
                >
                  Home
                </span>
              </>
            )}
          </NavLink>
        </div>
        <div className="w-[80px]">
          <Accordion
            // sx={{
            //   background: "transparent",
            //   boxShadow: "none",
            //   padding: 0,
            // }}

            sx={{
              boxShadow: "none",
              padding: "0",
              borderRadius: "18px !important",
              minHeight: "44px !important",

              "&.Mui-expanded": {
                background: "#DBEAFE", // slightly deeper when open
                borderRadius: "12px",
                minHeight: "44px !important",
              },
            }}
          >
            <AccordionSummary
              aria-controls="leave-menu"
              id="leave-header"
              sx={{
                padding: 0,
                margin: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                },
              }}
            >
              <div className="w-[80px] relative">
                <div className="relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md bg-white hover:bg-blue-200 transition-all duration-200 group">
                  <BsPerson className="w-6 h-6 mb-1 text-[#787878] group-hover:scale-110 transition-all duration-200" />

                  <span className="text-[0.65rem] font-semibold text-[#787878]">
                    Employee
                  </span>
                </div>
              </div>
            </AccordionSummary>

            <AccordionDetails sx={{ padding: 0, marginTop: "8px" }}>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="emp_reg"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
       transition-all duration-200 ease-in-out group
       ${
         isActive
           ? "bg-[#2663EB] text-white"
           : "bg-white hover:bg-blue-200 hover:text-[#2663EB]"
       }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdPersonAddAlt
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold transition-colors duration-200 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Employee Registration
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              <div className="w-[80px] relative my-2">
                <NavLink
                  to="emp_list"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
       transition-all duration-200 ease-in-out group
       ${
         isActive
           ? "bg-[#2663EB] text-white"
           : "bg-white hover:bg-blue-200 hover:text-[#2663EB]"
       }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdPeopleOutline
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold transition-colors duration-200 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Employee List
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="empJoinExitReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
       transition-all duration-200 ease-in-out group
       ${
         isActive
           ? "bg-[#2663EB] text-white"
           : "bg-white hover:bg-blue-200 hover:text-[#2663EB]"
       }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}
                      <div className="flex">
                        {/* <BsPersonPlus
                          className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                            isActive ? "text-white" : "text-[#787878]"
                          }`}
                        /> */}
                        
                        <BsPersonDash
                          className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                            isActive ? "text-white" : "text-[#787878]"
                          }`}
                        />
                      </div>

                      <span
                        className={`text-[0.65rem] font-semibold transition-colors duration-200 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Joining & Exit Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="empStatusReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
       transition-all duration-200 ease-in-out group
       ${
         isActive
           ? "bg-[#2663EB] text-white"
           : "bg-white hover:bg-blue-200 hover:text-[#2663EB]"
       }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <FaUserClock
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold transition-colors duration-200 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Employee Status Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="empVisaIDExpiryReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
       transition-all duration-200 ease-in-out group
       ${
         isActive
           ? "bg-[#2663EB] text-white"
           : "bg-white hover:bg-blue-200 hover:text-[#2663EB]"
       }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdBadge
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold transition-colors duration-200 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Visa / Emirates ID Expiry
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="w-[80px] relative">
          <NavLink
            to="bigCalendar"
            className={({ isActive }) =>
              `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
       transition-all duration-200 ease-in-out group
       ${
         isActive
           ? "bg-[#2663EB] text-white"
           : "bg-white hover:bg-blue-200 hover:text-[#2663EB]"
       }`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                )}

                <AiOutlineCalendar
                  className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                    isActive ? "text-white" : "text-[#787878]"
                  }`}
                />

                <span
                  className={`text-[0.65rem] font-semibold transition-colors duration-200 ${
                    isActive ? "text-white" : "text-[#787878]"
                  }`}
                >
                  Events
                </span>
              </>
            )}
          </NavLink>
        </div>
        <div className="w-[80px]">
          <Accordion
            // sx={{
            //   background: "transparent",
            //   boxShadow: "none",
            //   padding: 0,
            // }}

            sx={{
              boxShadow: "none",
              padding: "0",
              borderRadius: "18px !important",
              minHeight: "44px !important",

              "&.Mui-expanded": {
                background: "#DBEAFE", // slightly deeper when open
                borderRadius: "12px",
                minHeight: "44px !important",
              },
            }}
          >
            <AccordionSummary
              aria-controls="leave-menu"
              id="leave-header"
              sx={{
                padding: 0,
                margin: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                },
              }}
            >
              <div className="w-[80px] relative">
                <div className="relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md bg-white hover:bg-blue-200 transition-all duration-200 group">
                  <MdEventBusy className="w-6 h-6 mb-1 text-[#787878] group-hover:scale-110 transition-all duration-200" />

                  <span className="text-[0.65rem] font-semibold text-[#787878]">
                    Leave
                  </span>
                </div>
              </div>
            </AccordionSummary>

            <AccordionDetails sx={{ padding: 0, marginTop: "8px" }}>
              {/* Leave Allotment */}
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="leaveallotment"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <AiOutlineProfile
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Allotment
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              {/* Leave Application */}
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="leaveapplication"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdNoteAdd
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Application
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              {/* Leave Approval */}
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="leaveapproval"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdCheckCircleOutline
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Approval
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              {/* Leave Rejoin */}
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="leaverejoin"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdAutorenew
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Rejoin
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              {/* Leave Category */}
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="leavecat"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdCategory
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Category
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              {/* Leave Balance Report */}
              {/* <div className="w-[80px] relative my-2">
                <NavLink
                  to="leaveBalanceReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsClipboardData
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Balance Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div> */}
              {/*  Leave Ledger */}
              {/* <div className="w-[80px] relative my-2">
                <NavLink
                  to="leaveLedger"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsJournalText
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Leave Ledger
                      </span>
                    </>
                  )}
                </NavLink>
              </div> */}
              {/*Leave Encashment Report */}
              {/* <div className="w-[80px] relative my-2">
                <NavLink
                  to="leaveEncashmentReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsCashStack
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Encashment Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div> */}
              {/* Leave Requests & Approval Status */}
              {/* <div className="w-[80px] relative my-2">
                <NavLink
                  to="leaveRequestApprovalStatus"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsListCheck
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Requests & Approval Status
                      </span>
                    </>
                  )}
                </NavLink>
              </div> */}
              {/* Sick Leave / Medical Leave Tracking */}
              {/* <div className="w-[80px] relative my-2">
                <NavLink
                  to="medicalLeaveTracking"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
             transition-all duration-200 ease-in-out group
             ${
               isActive
                 ? "bg-[#2663EB] text-white"
                 : "bg-white hover:bg-blue-200"
             }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <FaNotesMedical
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                       Medical Leave Tracking
                      </span>
                    </>
                  )}
                </NavLink>
              </div> */}
            </AccordionDetails>
          </Accordion>
        </div>
        {/* ///////////// */}

        <div className="w-[80px]  ">
          <Accordion
            // sx={{
            //   background: "#EFF4FF",
            //   boxShadow: "none",
            //   padding: 0,
            //   borderRadius: "44px",
            // }}

            sx={{
              boxShadow: "none",
              padding: "0",
              borderRadius: "18px !important",
              minHeight: "44px !important",

              "&.Mui-expanded": {
                background: "#DBEAFE", // slightly deeper when open
                borderRadius: "12px",
                minHeight: "44px !important",
              },
            }}
          >
            {/* Accordion Header */}
            <AccordionSummary
              aria-controls="payroll-menu"
              id="payroll-header"
              sx={{
                padding: 0,
                margin: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                },
              }}
            >
              <div className="w-[80px] relative">
                <div className="relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md bg-white hover:bg-blue-200 transition-all duration-200 group">
                  <MdOutlinePayment className="w-6 h-6 mb-1 text-[#787878] group-hover:scale-110 transition-all duration-200" />

                  <span className="text-[0.55rem] font-semibold text-[#787878] text-center">
                    Payroll Menu
                  </span>
                </div>
              </div>
            </AccordionSummary>

            {/* Payroll */}
            <AccordionDetails sx={{ padding: 0, marginTop: "8px" }}>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="payrollMain"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdOutlinePayment
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Payroll
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              {/* Add / Deduct */}
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="payroll"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdOutlinePayment
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Add / Deduct
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              {/* WPS */}
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="wps"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <FaMoneyCheckAlt
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878] "
                        }`}
                      />

                      <span
                        className={`text-[0.65rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878] "
                        }`}
                      >
                        WPS
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="w-[80px]">
          <Accordion
            // sx={{
            //   background: "transparent",
            //   boxShadow: "none",
            //   padding: 0,
            // }}

            sx={{
              boxShadow: "none",
              padding: "0",
              borderRadius: "18px !important",
              minHeight: "44px !important",

              "&.Mui-expanded": {
                background: "#DBEAFE", // slightly deeper when open
                borderRadius: "12px",
                minHeight: "44px !important",
              },
            }}
          >
            {/* Accordion Header */}
            <AccordionSummary
              aria-controls="payroll-menu"
              id="payroll-header"
              sx={{
                padding: 0,
                margin: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                },
              }}
            >
              <div className="w-[80px] relative">
                <div className="relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md bg-white hover:bg-blue-200 transition-all duration-200 group">
                  <MdAccessTime className="w-6 h-6 mb-1 text-[#787878] group-hover:scale-110 transition-all duration-200" />

                  <span className="text-[0.55rem] font-semibold text-[#787878] text-center">
                    Attendance
                  </span>
                </div>
              </div>
            </AccordionSummary>

            {/* Payroll */}
            <AccordionDetails sx={{ padding: 0, marginTop: "8px" }}>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="atdcevaluation"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BiCheckCircle
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Evaluation
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              <div className="w-[80px] relative my-2">
                <NavLink
                  to="timesheet"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsClipboardCheck
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Timesheet
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              <div className="w-[80px] relative my-2">
                <NavLink
                  to="timesheetSummaryReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsClockHistory
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Timesheet Summary Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="attendancePunchDetailsReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdPunchClock 
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Attendance Punch Details
                      </span>
                    </>
                  )}
                </NavLink>
              </div>

              {/* <div className="w-[80px] relative my-2">
                <NavLink
                  to="monthlyAttendanceReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsCalendarCheck
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Monthly Attendance Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="dailyAttendanceReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsCalendarDay
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Daily Attendance Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div> */}
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="absenceReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsCalendarX
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Absence Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="overtimeReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsClock
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Overtime Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="lateEarlyReport"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdAccessTime
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold text-center ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Late Coming / Early Leaving Report
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="w-[80px]">
          <Accordion
            // sx={{
            //   background: "transparent",
            //   boxShadow: "none",
            //   padding: 0,
            // }}

            sx={{
              boxShadow: "none",
              padding: "0",
              borderRadius: "18px !important",
              minHeight: "44px !important",

              "&.Mui-expanded": {
                background: "#DBEAFE", // slightly deeper when open
                borderRadius: "12px",
                minHeight: "44px !important",
              },
            }}
          >
            {/* Accordion Header */}
            <AccordionSummary
              aria-controls="payroll-menu"
              id="payroll-header"
              sx={{
                padding: 0,
                margin: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                },
              }}
            >
              <div className="w-[80px] relative">
                <div className="relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md bg-white hover:bg-blue-200 transition-all duration-200 group">
                  <MdSettings className="w-6 h-6 mb-1 text-[#787878] group-hover:scale-110 transition-all duration-200" />

                  <span className="text-[0.55rem] font-semibold text-[#787878] text-center">
                    Settings
                  </span>
                </div>
              </div>
            </AccordionSummary>

            {/* Payroll */}
            <AccordionDetails sx={{ padding: 0, marginTop: "8px" }}>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="holiday"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdHolidayVillage
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Holiday
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="w-[80px]">
          <Accordion
            // sx={{
            //   background: "transparent",
            //   boxShadow: "none",
            //   padding: 0,
            // }}

            sx={{
              boxShadow: "none",
              padding: "0",
              borderRadius: "18px !important",
              minHeight: "44px !important",

              "&.Mui-expanded": {
                background: "#DBEAFE", // slightly deeper when open
                borderRadius: "12px",
                minHeight: "44px !important",
              },
            }}
          >
            {/* Accordion Header */}
            <AccordionSummary
              aria-controls="payroll-menu"
              id="payroll-header"
              sx={{
                padding: 0,
                margin: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                },
              }}
            >
              <div className="w-[80px] relative">
                <div className="relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md bg-white hover:bg-blue-200 transition-all duration-200 group">
                  <RiUserUnfollowLine className="w-6 h-6 mb-1 text-[#787878] group-hover:scale-110 transition-all duration-200" />

                  <span className="text-[0.55rem] font-semibold text-[#787878] text-center">
                    End of Service
                  </span>
                </div>
              </div>
            </AccordionSummary>

            {/* Application */}
            <AccordionDetails sx={{ padding: 0, marginTop: "8px" }}>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="endOfServiceApplication"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <HiOutlineDocumentAdd
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Application
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="endOfServiceApproval"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdHowToReg
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Approval
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              {/* <div className="w-[80px] relative my-2">
                <NavLink
                  to="gratuityMonitor"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <BsGraphUpArrow
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Gratuity Monitor
                      </span>
                    </>
                  )}
                </NavLink>
              </div> */}
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="w-[80px]">
          <Accordion
            // sx={{
            //   background: "transparent",
            //   boxShadow: "none",
            //   padding: 0,
            // }}

            sx={{
              boxShadow: "none",
              padding: "0",
              borderRadius: "18px !important",
              minHeight: "44px !important",

              "&.Mui-expanded": {
                background: "#DBEAFE", // slightly deeper when open
                borderRadius: "12px",
                minHeight: "44px !important",
              },
            }}
          >
            {/* Accordion Header */}
            <AccordionSummary
              aria-controls="payroll-menu"
              id="payroll-header"
              sx={{
                padding: 0,
                margin: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                },
              }}
            >
              <div className="w-[80px] relative">
                <div className="relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md bg-white hover:bg-blue-200 transition-all duration-200 group">
                  <FaTruckMoving className="w-6 h-6 mb-1 text-[#787878] group-hover:scale-110 transition-all duration-200" />

                  <span className="text-[0.55rem] font-semibold text-[#787878] text-center">
                    Fleet Management
                  </span>
                </div>
              </div>
            </AccordionSummary>

            {/* Application */}
            <AccordionDetails sx={{ padding: 0, marginTop: "8px" }}>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="fleetInformation"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      {/* <FaTruckMoving */}
                      <FaCarSide
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Fleet Information
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              <div className="w-[80px] relative my-2">
                <NavLink
                  to="fleetList"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <MdAssignmentLate
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Fleet List
                      </span>
                    </>
                  )}
                </NavLink>
              </div>
              {/* <div className="w-[80px] relative my-2">
                <NavLink
                  to="insuranceExpiry"
                  className={({ isActive }) =>
                    `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
            transition-all duration-200 ease-in-out group
            ${
              isActive
                ? "bg-[#2663EB] text-white"
                : "bg-white hover:bg-blue-200"
            }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4"></span>
                      )}

                      <AiOutlineFileExclamation
                        className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      />

                      <span
                        className={`text-[0.55rem] font-semibold ${
                          isActive ? "text-white" : "text-[#787878]"
                        }`}
                      >
                        Insurance Expiry
                      </span>
                    </>
                  )}
                </NavLink>
              </div> */}
            </AccordionDetails>
          </Accordion>
        </div>

        {/*   <Accordion
          sx={{
            background: "#F3F2FA",
            // background: "#DEDEDE",
            boxShadow: "none",
            paddingRight: "4px",
            paddingLeft: "4px",
            borderRadius: "8px",
            width: "65px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: "0px",
              margin: "0px",
              "& .MuiAccordionSummary-content": {
                margin: "4px !important",
                padding: "0px",
              },

              "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: "0px !important",
                background: "#4B5563",

                marginTop: "12px !important ",
                text: "#ffffff",
                borderRadius: "4px",
                "& .group": {
                  "& .text-gray-700": {
                    color: "#ffffff !important", // White icon when expanded
                  },
                  "& .text-gray-800": {
                    color: "#ffffff !important", // White text when expanded
                  },
                  "& .group-hover\\:text-white": {
                    color: "#ffffff", // Ensure hover state retains white
                  },
                  "& .group-focus\\:text-white": {
                    color: "#ffffff", // Ensure focus state retains white
                  },
                },
              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type": {
                marginTop: "0px",
              },
            }}
          >
            <div className="w-[80px]">
              <li className="w-full relative group">
                <Link
                  // to="payroll"
                  className="group bg-[#2663EB] flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out  group-hover:bg-gray-600 focus:bg-gray-600  hover:-translate-y-1 hover:scale-80 active:scale-95"
                >
                  <BiFolderOpen className="w-6 h-6 mb-1 text-white  group-hover:text-white group-focus:text-white  transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                  <span className="text-[0.55rem] font-semibold text-white  group-hover:text-white group-focus:text-white  transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                    Document Manage
                  </span>
                </Link>
              </li>
            </div>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group my-2">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <BiFolderOpen className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.50rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Document Management
                </span>
              </Link>
            </li>
          </AccordionDetails>

          <AccordionDetails
            sx={{
              padding: "0px",
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="w-full relative group mt-2">
              <Link
                // to="payrollMain"
                className="flex flex-col shadow-md justify-center items-center rounded text-center p-2 transition-all duration-200 ease-in-out bg-gray-400 group-hover:bg-gray-600 focus:bg-gray-600 hover:-translate-y-1 hover:scale-80 active:scale-95"
              >
                <MdEventBusy className="w-6 h-6 mb-1 text-white group-hover:text-white transition-all duration-300 group-hover:animate-bounce hover:scale-110" />
                <span className="text-[0.55rem] font-semibold text-white group-hover:text-white transition-colors duration-200 group-hover:animate-bounce hover:scale-110">
                  Document Expiry
                </span>
              </Link>
            </li>
          </AccordionDetails>
        </Accordion> */}

        {/* <div className="">
          <button
            onClick={onSignOut}
            className="flex justify-center items-center w-full bg-red-500 text-white p-2 rounded"
          >
            <div className="flex flex-col justify-center items-center text-center ">
              <AiOutlineExport className="w-6 h-6" />
              <span className="text-xs">Sign Out</span>
            </div>
          </button>
        </div> */}

        <li className="w-full relative group my-4">
          <div className="flex ">
            <img className=" object-cover" src={cbxLogo} alt="" />
          </div>
        </li>
      </ul>
    </aside>
  );
};

export default NewSidebarOld;
